/**
 * Downloads content as a file by creating a temporary anchor element
 * @param {string|Blob} content - The file content to download (string or Blob)
 * @param {string} filename - The name for the downloaded file
 * @param {string} mimeType - The MIME type (default: 'application/csv')
 */
export const downloadFile = (content, filename, mimeType = 'application/csv') => {
  const file = content instanceof Blob ? content : new Blob([content], { type: mimeType })
  const fileUrl = window.URL.createObjectURL(file)

  const element = document.createElement('a')
  element.href = fileUrl
  element.setAttribute('download', filename)
  document.body.appendChild(element)
  element.click()
  element.remove()
  window.URL.revokeObjectURL(fileUrl)
}
